/**
 * Re-export from core (single source of truth).
 */
import '@korvo/core/lib/console-error-normalized';

export type { NormalizedError } from '@korvo/core/lib/normalize-error';
export { normalizeError } from '@korvo/core/lib/normalize-error';
